import { ProductDetail } from '@absg/api-formulary';
import { InventoryItem } from '@absg/nim-client-shared';

export class DispenseStateService {
  assignedItems: ProductDetail[] = [];
  products: InventoryItem[] = [];
  allInventoryItems: InventoryItem[] = [];
}
